import React from 'react';
import {
  FormControl,
  FormLabel,
  FormGroup,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  GridProps,
  FormHelperText,
} from '@mui/material';
import { FORM_CLASSES } from '../../../constants';

export interface RadioOption {
  value: string;
  label: string;
}

export interface RadioButtonGroupProps {
  id: string;
  label: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  options?: RadioOption[];
  required?: boolean;
  disabled?: boolean;
  gridProps?: GridProps;
  direction?: 'row' | 'column';
  error?: boolean;
  helperText?: string;
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  id,
  label,
  value = '',
  onChange,
  onBlur,
  options = [
    { value: 'Y', label: 'Yes' },
    { value: 'N', label: 'No' }
  ],
  required = false,
  disabled = false,
  gridProps = { md: 6, xs: 12 },
  direction = 'row',
  error = false,
  helperText,
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl className={FORM_CLASSES.FORM_CONTROL} error={error}>
        <FormLabel id={`${id}Label`} htmlFor={id}>
          {label}
          {required ? <sup>*</sup> : <sup>&nbsp;</sup>}
        </FormLabel>
        <FormGroup className="shift-left" sx={{ marginLeft: 1 }}>
          <RadioGroup
            row={direction === 'row'}
            aria-labelledby={`${id}Label`}
            name={id}
            value={value}
            sx={{ paddingTop: 1 }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio disabled={disabled}  onChange={onChange} onBlur={onBlur} />}
                label={option.label}
                name={id}
           

                className="mt-0"
                checked={value === option.value}
              />
            ))}
          </RadioGroup>
        </FormGroup>
        {helperText && (
          <FormHelperText sx={{ marginTop: 0.5, marginLeft: 1 }}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
};

export default RadioButtonGroup;